module.exports = __webpack_public_path__ + "media/img/testimg-1e1b3b615496a7da8ed77909a6eb579e.png";